/* Custom Mylar Bag Builder – The Baggie Store */
(() => {
  const root = document.querySelector('[data-cmb]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];

  const product = JSON.parse($('[data-cmb-product]').textContent);
  const form = $('[data-cmb-form]');
  const stage = root.querySelector('.cmb__stage');
  const maxBytes = Number(root.dataset.maxMb || 20) * 1024 * 1024;
  const designVariant = Number(root.dataset.designVariant || 0);
  const designPrice = Number(root.dataset.designPrice || 0);
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  const el = {
    variant: $('[data-cmb-variant]'),
    job: $('[data-cmb-job]'),
    price: $('[data-cmb-price]'),
    unit: $('[data-cmb-unit]'),
    ref: $('[data-cmb-ref]'),
    agree: $('[data-cmb-agree]'),
    summary: $('[data-cmb-summary]'),
    submit: $('[data-cmb-submit]'),
    btnText: $('[data-cmb-btn-text]'),
    error: $('[data-cmb-error]'),
    sides: $('[data-cmb-sides]'),
    back: $('[data-cmb-back]'),
    same: $('[data-cmb-same]'),
    frontLabel: $('[data-cmb-front-label]'),
  };

  let mode = 'upload';
  const DROP_DEFAULT = '<strong>Drop your file here</strong> or click to browse';

  /* One upload slot (front or back): drop zone + preview layer */
  function makeSlot(side) {
    const s = {
      side,
      ok: false,
      url: null,
      file: $(`[data-cmb-file="${side}"]`),
      drop: $(`[data-cmb-drop="${side}"]`),
      dropText: $(`[data-cmb-drop-text="${side}"]`),
      msg: $(`[data-cmb-file-msg="${side}"]`),
      img: $(`[data-cmb-art-img="${side}"]`),
      pdf: $(`[data-cmb-pdf="${side}"]`),
      pdfName: $(`[data-cmb-pdf-name="${side}"]`),
      placeholder: $(`[data-cmb-placeholder="${side}"]`),
    };
    s.setMsg = (text, kind) => {
      s.msg.textContent = text;
      s.msg.className = `cmb__msg ${kind ? `is-${kind}` : ''}`;
    };
    s.show = (kind, src, name) => {
      if (s.url && kind !== 'png') { URL.revokeObjectURL(s.url); s.url = null; }
      s.img.hidden = kind !== 'png';
      s.pdf.hidden = kind !== 'pdf';
      s.placeholder.hidden = !!kind;
      if (kind === 'png') s.img.src = src;
      if (kind === 'pdf') s.pdfName.textContent = name;
    };
    s.reset = (msg) => {
      s.file.value = '';
      s.ok = false;
      s.drop.classList.remove('is-ok');
      s.dropText.innerHTML = DROP_DEFAULT;
      s.show(null);
      s.setMsg(msg || '', msg ? 'warn' : '');
      update();
    };
    s.handle = (file) => {
      s.ok = false;
      s.drop.classList.remove('is-ok');
      if (!file) { s.reset(); return; }

      const isPng = file.type === 'image/png' || /\.png$/i.test(file.name);
      const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
      if (!isPng && !isPdf) { s.reset('Please upload a PNG or PDF file.'); return; }
      if (file.size > maxBytes) { s.reset(`That file is ${(file.size / 1048576).toFixed(1)} MB. Max is ${root.dataset.maxMb} MB. Try exporting a smaller PDF or PNG.`); return; }

      s.dropText.innerHTML = '';
      const strong = document.createElement('strong');
      strong.textContent = file.name;
      s.dropText.append(strong, ` · ${(file.size / 1048576).toFixed(2)} MB · click to change`);
      s.drop.classList.add('is-ok');
      s.ok = true;
      if (side === 'back' || stage.dataset.side === 'back') setSide(side);

      if (isPdf) {
        s.show('pdf', null, file.name);
        s.setMsg('PDF received. Our team will check it and send you a proof.', 'ok');
        update();
        return;
      }
      if (s.url) URL.revokeObjectURL(s.url);
      s.url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        s.show('png', s.url);
        const { naturalWidth: w, naturalHeight: h } = img;
        if (w < 1200 || h < 1500) {
          s.setMsg(`Heads up: ${w} × ${h}px is low-res for a 4" × 5" bag (we recommend 1200 × 1500px+ at 300 DPI). It may print blurry. You can still order and we'll flag it on your proof.`, 'warn');
        } else {
          s.setMsg(`Looks good: ${w} × ${h}px.`, 'ok');
        }
        update();
      };
      img.onerror = () => s.reset('We could not read that PNG. Try re-exporting it.');
      img.src = s.url;
    };
    ['dragenter', 'dragover'].forEach((t) => s.drop.addEventListener(t, () => s.drop.classList.add('is-over')));
    ['dragleave', 'drop'].forEach((t) => s.drop.addEventListener(t, () => s.drop.classList.remove('is-over')));
    s.file.addEventListener('change', () => s.handle(s.file.files[0]));
    return s;
  }

  const front = makeSlot('front');
  const back = makeSlot('back');

  function money(cents) {
    const amt = (cents / 100);
    const fmt = (n, dec) => n.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return fmt(Math.round(amt), 0);
      if (k === 'amount_with_comma_separator') return fmt(amt, 2).replace('.', ',');
      return fmt(amt, 2);
    });
  }

  function selectedOptions() {
    return product.options.map((_, i) => {
      const c = root.querySelector(`[data-cmb-option="${i}"]:checked`);
      return c ? c.value : null;
    });
  }
  function currentVariant() {
    const sel = selectedOptions();
    return product.variants.find((v) => v.options.every((o, i) => o === sel[i]));
  }
  function bagCount(v) {
    const m = v && v.options.join(' ').match(/([\d,]+)\s*bags/i);
    return m ? Number(m[1].replace(/,/g, '')) : 0;
  }
  function twoSided() {
    return selectedOptions().some((o) => /back/i.test(o || ''));
  }
  function sameAsFront() {
    return !!(el.same && el.same.checked);
  }

  function setSide(side) {
    stage.dataset.side = side;
    $$('[data-cmb-side]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cmbSide === side)));
  }

  /* Show/hide the back upload area based on Print option + mode */
  function syncBack() {
    const on = twoSided() && mode === 'upload';
    el.back.hidden = !on;
    el.sides.hidden = !twoSided();
    el.frontLabel.hidden = !on;
    el.same.disabled = !on;
    const needFile = on && !sameAsFront();
    back.file.disabled = !needFile;
    back.drop.hidden = !needFile;
    back.msg.hidden = !needFile;
    if (!twoSided()) setSide('front');
    stage.dataset.sameBack = String(sameAsFront());
  }

  function update() {
    const v = currentVariant();
    if (v) {
      el.variant.value = v.id;
      el.price.textContent = money(v.price);
      const n = bagCount(v);
      el.unit.textContent = n ? `${money(Math.round(v.price / n))} / bag` : '';
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
    const finish = (selectedOptions().find((o) => /matte|gloss|holo/i.test(o || '')) || 'Matte');
    stage.dataset.finish = finish;
    const w = root.querySelector('[data-cmb-window]:checked');
    stage.dataset.window = w ? w.value : 'No window';
    syncBack();
    renderSummary(v);
    validate(false);
  }

  function renderSummary(v) {
    if (!v) { el.summary.innerHTML = '<div>This combination is unavailable.</div>'; return; }
    const rows = [[v.title, money(v.price)]];
    if (mode === 'design') rows.push(['Custom design service', money(designPrice)]);
    const total = v.price + (mode === 'design' ? designPrice : 0);
    el.summary.replaceChildren(
      ...rows.map(([a, b]) => row(a, b)),
      row('Total', money(total), 'cmb__total')
    );
    el.btnText.textContent = `Add to cart · ${money(total)}`;
  }
  function row(a, b, cls) {
    const d = document.createElement('div');
    if (cls) d.className = cls;
    const s1 = document.createElement('span'); s1.textContent = a;
    const s2 = document.createElement('span'); s2.textContent = b;
    d.append(s1, s2);
    return d;
  }

  function setPlaceholder(slot, title, sub) {
    slot.placeholder.querySelector('strong').textContent = title;
    slot.placeholder.querySelector('span').textContent = sub;
  }

  function setMode(m) {
    mode = m;
    $$('[data-cmb-pane]').forEach((p) => {
      const on = p.dataset.cmbPane === m;
      p.hidden = !on;
      p.querySelectorAll('input, textarea').forEach((i) => (i.disabled = !on));
    });
    if (m === 'design') {
      front.show(null);
      back.show(null);
      setPlaceholder(front, 'Designed by our team', "We'll email you a proof");
      setPlaceholder(back, 'Designed by our team', "We'll email you a proof");
    } else {
      setPlaceholder(front, 'Your design here', 'Upload a PNG or PDF to preview');
      setPlaceholder(back, 'Back design here', 'Upload a PNG or PDF to preview');
      if (front.file.files[0]) front.handle(front.file.files[0]);
      if (back.file.files[0]) back.handle(back.file.files[0]);
    }
    update();
  }

  function validate(show) {
    let err = '';
    if (!currentVariant()) err = 'Please pick a valid combination.';
    else if (mode === 'upload' && !front.ok) err = twoSided() ? 'Please upload your front artwork (PNG or PDF).' : 'Please upload your PNG or PDF artwork.';
    else if (mode === 'upload' && twoSided() && !sameAsFront() && !back.ok) err = 'Please upload your back artwork, or tick "Use the same artwork on the back".';
    else if (mode === 'design') {
      const missing = $$('[data-cmb-design-req]').some((i) => !i.value.trim());
      if (missing) err = 'Please add your brand name and describe your design.';
    }
    if (!err && !el.agree.checked) err = 'Please confirm the artwork / proof checkbox.';
    if (show) el.error.textContent = err;
    else if (!err) el.error.textContent = '';
    return !err;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!validate(true)) return;
    el.submit.setAttribute('aria-busy', 'true');
    el.btnText.textContent = mode === 'upload' ? 'Uploading artwork…' : 'Adding to cart…';

    const job = `CMB-${Date.now().toString(36).toUpperCase().slice(-6)}`;
    el.job.value = job;

    const fd = new FormData(form);
    [...fd.keys()].filter((k) => k.startsWith('cmb-')).forEach((k) => fd.delete(k));
    fd.set('properties[Artwork]', mode === 'upload' ? 'Customer upload' : 'Designed by The Baggie Store');
    if (mode === 'upload' && !twoSided()) fd.delete('properties[Back artwork]');
    for (const [k, v] of [...fd.entries()]) {
      if (typeof v === 'string' && !v.trim()) fd.delete(k);
      if (v instanceof File && !v.name) fd.delete(k);
    }

    try {
      const addUrl = `${root.dataset.cartAdd}.js`;
      const res = await fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || 'Could not add to cart.');

      if (mode === 'design' && designVariant) {
        const brand = (form.querySelector('[name="properties[Brand name]"]') || {}).value || '';
        const res2 = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: designVariant, quantity: 1, properties: { 'Job #': job, 'For': product.title, 'Brand name': brand } }] }),
        });
        if (!res2.ok) throw new Error('Bags added, but the design service could not be added. Please contact us.');
      }
      window.location.href = root.dataset.cartUrl || '/cart';
    } catch (err) {
      el.error.textContent = err.message;
      el.submit.removeAttribute('aria-busy');
      renderSummary(currentVariant());
    }
  });

  $$('[data-cmb-option], [data-cmb-window]').forEach((i) => i.addEventListener('change', update));
  $$('[data-cmb-mode]').forEach((i) => i.addEventListener('change', () => setMode(i.value)));
  $$('[data-cmb-design-req]').forEach((i) => i.addEventListener('input', () => validate(false)));
  $$('[data-cmb-side]').forEach((b) => b.addEventListener('click', () => setSide(b.dataset.cmbSide)));
  el.same.addEventListener('change', update);
  el.agree.addEventListener('change', () => validate(false));

  const vid = Number(new URLSearchParams(location.search).get('variant'));
  const pre = vid && product.variants.find((v) => v.id === vid);
  if (pre) pre.options.forEach((o, i) => {
    const r = [...root.querySelectorAll(`[data-cmb-option="${i}"]`)].find((x) => x.value === o);
    if (r) r.checked = true;
  });
  setSide('front');
  setMode('upload');
})();
